// Date 2022-06-14 20:26:00

import partyBuildingTest from "@/store/party-building/PartyBuildingTestStore.js";

const genericEntities = [
    'partyBuildingTest'
]

const entities = {
    partyBuildingTest
}

export {genericEntities}

export default entities